import React from "react";
import {Card, CardContent, Typography} from "@mui/material";
import {Trans} from "react-i18next";

const LockerCard = ({locker, admin}) => {
    return (
        <Card sx={{maxWidth: 400, m: 2, p: 2, boxShadow: 3}}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {locker.name}
                </Typography>
                <Typography variant="body1">
                    <strong><Trans i18nKey={'easyBox.address'}/>:</strong> {locker.address}
                </Typography>
                <Typography variant="body1">
                    <strong><Trans i18nKey={'addressForm.city'}/>:</strong> {locker.city}
                </Typography>
                <Typography variant="body1">
                    <strong><Trans i18nKey={'addressForm.county'}/>:</strong> {locker.county}
                </Typography>
                <Typography variant="body1">
                    <strong><Trans i18nKey={'addressForm.zipCode'}/>:</strong> {locker.postalCode}
                </Typography>
                {admin && <>
                    <Typography variant="body1">
                        <strong>Locker id:</strong> {locker.lockerId}
                    </Typography>
                    <Typography variant="body1">
                        <strong>Ooh type:</strong> {locker.oohType}
                    </Typography>
                </>}
            </CardContent>
        </Card>
    );
};

export default LockerCard;
